let src
// src='https://test.en.degree.qsxueli.com:443'
// src='http://192.168.31.56'
// src = 'http://192.168.1.79'
// src = 'https://404xuexi.qsxueli.com'    //线上测试请求
// src = 'https://xuexi.qsxueli.com'        //线上正式请求
src = 'http://test.en.degree.qsxueli.com:8980'   //本地请求
const serverSrc= src      //请求域名
export default {
    serverSrc
}


// WEBPACK FOOTER //
// ./src/local_request.js